import { useMemo } from 'react';
import { useBindViewer } from '../../hooks/useBindViewer';
import {
  canCancelSocialEvent,
  canChangeUserRoleInEvent,
  canCreateConferenceEvent,
  canCreateEvent,
  canCreateWebinarEvent,
  canDeclineEvent,
  canDeleteEvent,
  canDeleteRailsUserFromEvent,
  canDeleteUserFromEvent,
  canDuplicateEvent,
  canDuplicateSocialEvent,
  canEditEvent,
  canEditSocialEvent,
  canEditTelehealthEvent,
  canEditUserRoleInEvent,
  canInviteCommunities,
  canInviteRailsUserToEvent,
  canInviteUserToEvent,
  canManageEventChannels,
  canManageEventUsers,
  canReportEvent,
  canReportSocialEvent,
  canRequestTelehealthEvent,
  canViewEventApprovalStatus,
  canViewTelehealth,
  isEventsAdmin,
} from '../permissions';

export const useEventPermissions = () => {
  const bindViewer = useBindViewer();

  return useMemo(
    () => ({
      canCancelSocialEvent: bindViewer(canCancelSocialEvent),
      canChangeUserRoleInEvent: bindViewer(canChangeUserRoleInEvent),
      canCreateConferenceEvent: bindViewer(canCreateConferenceEvent),
      canCreateEvent: bindViewer(canCreateEvent),
      canCreateWebinarEvent: bindViewer(canCreateWebinarEvent),
      canDeclineEvent: bindViewer(canDeclineEvent),
      canDeleteEvent: bindViewer(canDeleteEvent),
      canDeleteRailsUserFromEvent: bindViewer(canDeleteRailsUserFromEvent),
      canDeleteUserFromEvent: bindViewer(canDeleteUserFromEvent),
      canDuplicateEvent: bindViewer(canDuplicateEvent),
      canDuplicateSocialEvent: bindViewer(canDuplicateSocialEvent),
      canEditEvent: bindViewer(canEditEvent),
      canEditSocialEvent: bindViewer(canEditSocialEvent),
      canEditTelehealthEvent: bindViewer(canEditTelehealthEvent),
      canEditUserRoleInEvent: bindViewer(canEditUserRoleInEvent),
      canInviteCommunities: bindViewer(canInviteCommunities),
      canInviteRailsUserToEvent: bindViewer(canInviteRailsUserToEvent),
      canInviteUserToEvent: bindViewer(canInviteUserToEvent),
      canManageEventChannels: bindViewer(canManageEventChannels),
      canManageEventUsers: bindViewer(canManageEventUsers),
      canReportEvent: bindViewer(canReportEvent),
      canReportSocialEvent: bindViewer(canReportSocialEvent),
      canRequestTelehealthEvent: bindViewer(canRequestTelehealthEvent),
      canViewEventApprovalStatus: bindViewer(canViewEventApprovalStatus),
      canViewTelehealth: bindViewer(canViewTelehealth),
      isEventsAdmin: bindViewer(isEventsAdmin),
    }),
    [bindViewer],
  );
};
